/*
 *
 * TenantDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { requestAction } from 'domain/typeConstants/action';
import * as actionCreators from './actions';

class TenantDxGridContainer extends React.PureComponent {

  handleRowDoubleClick = (record) => this.props.executeViewAction(record.id);

  handleActionExecuting = (actionName, ids) => {
    switch (actionName) {
      case requestAction.ADD:
        this.props.executeAddAction();
        break;

      case requestAction.EDIT:
        this.props.executeEditAction(ids[0]);
        break;

      case requestAction.COPY:
        this.props.executeCopyAction(ids[0]);
        break;

      case requestAction.VIEW:
        this.props.executeViewAction(ids[0]);
        break;

      case requestAction.CLOSE:
        this.props.executeCloseAction(ids);
        break;

      case requestAction.ACCEPT:
        this.props.executeAcceptAction(ids);
        break;

      case requestAction.CLOSE_BY_TENANT:
        this.props.executeClosedByTenantAction(ids[0]);
        break;

      case requestAction.AGREED_ESTIMATION_COST:
        this.props.executeAgreedEstimationCostAction(ids[0]);
        break;

      default:
        throw new Error('Executed a unknown action.');
    }
  };

  render() {
    const { component, viewName } = this.props;
    return React.cloneElement(component, {
      viewName,
      onActionExecuting: this.handleActionExecuting,
      onRowDoubleClick: this.handleRowDoubleClick,
    });
  }
}

TenantDxGridContainer.propTypes = {
  component: PropTypes.node.isRequired,
  executeAcceptAction: PropTypes.func.isRequired,
  executeAddAction: PropTypes.func.isRequired,
  executeCloseAction: PropTypes.func.isRequired,
  executeCopyAction: PropTypes.func.isRequired,
  executeEditAction: PropTypes.func.isRequired,
  executeViewAction: PropTypes.func.isRequired,
  executeClosedByTenantAction: PropTypes.func.isRequired,
  executeAgreedEstimationCostAction: PropTypes.func.isRequired,
  viewName: PropTypes.string.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(null, mapDispatchToProps)(TenantDxGridContainer);
